import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { PageHero } from '../components/PageHero';
import { SEO } from '../components/SEO';
import { FileText } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO page="impressum" />
      <Navbar />
      <main className="flex-1">
        
        {/* Einheitlicher Hero mit PageHero Komponente */}
        <PageHero
          title="Impressum"
          subtitle="Angaben gemäß § 5 TMG und verantwortliche Stellen"
          badges={[
            { icon: FileText, text: 'Rechtliche Informationen', bgColor: 'bg-slate-600 text-white' },
            { text: 'Erste Hilfe Bottrop', variant: 'white' }
          ]}
          backgroundImage="https://customer-assets.emergentagent.com/job_erste-hilfe-portal/artifacts/qrd4fjxg_C07669FC-5A78-4A59-B295-D1148E3DD6DE.png"
          backgroundPosition="center 40%"
          variant="simple"
        />

        {/* INHALT - Same container width as navbar */}
        <section className="py-12 sm:py-16">
          <div className="max-w-[1664px] mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none text-slate-600 space-y-6">
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Angaben gemäß § 5 TMG</h2>
              <p>
                Erste Hilfe Germany GbR<br />
                Poststraße 6<br />
                46236 Bottrop<br />
                Deutschland
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Vertretungsberechtigte Gesellschafter</h2>
              <p>
                Vertretungsberechtigte Gesellschafter der Erste Hilfe Germany GbR:<br /><br />
                Herr Yasar Kartal<br />
                Herr Jan Hassel<br /><br />
                Die Gesellschaft wird durch die Gesellschafter gemeinschaftlich vertreten.<br />
                Beide Gesellschafter haften im Rahmen der gesetzlichen Vorschriften.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Kontakt</h2>
              <p>
                Telefon: 02041 9878 666<br />
                Mobil: 0176 8015 1197<br />
                E-Mail: info@erstehilfebottrop.de
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Verantwortlich im Sinne des § 18 MStV</h2>
              <p>
                Verantwortlich für den Inhalt:<br /><br />
                Herr Yasar Kartal<br />
                Herr Jan Hassel<br />
                Poststraße 6<br />
                46236 Bottrop
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Aufsichtsbehörde</h2>
              <p>
                VBG – Verwaltungs-Berufsgenossenschaft<br />
                Riemenschneiderstraße 2<br />
                97072 Würzburg
              </p>
              <p>
                Weitere Informationen:<br />
                <a href="http://dguv.de/fb-erstehilfe" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:underline">
                  http://dguv.de/fb-erstehilfe
                </a>
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Kennziffer der ermächtigten Stelle gemäß § 26 DGUV Vorschrift 1</h2>
              <p>
                Kennziffer: 8.1482
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Mitgliedschaften</h2>
              <p>
                Mitglied im Verband der Erste-Hilfe-Schulen e. V.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Streitschlichtung</h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:underline"> https://ec.europa.eu/consumers/odr</a>.
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Haftung für Inhalte</h2>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                Tätigkeit hinweisen.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Haftung für Links</h2>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
                der Seiten verantwortlich.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Urheberrecht</h2>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default ImpressumPage;
